import React from 'react'
import styles from './Leaderboard.module.css'
import winnersbackground from './images/Group4661.svg'
import backgroundlines from './images/lines (1).svg'
import clsx from 'clsx'
import { LeaderboardData } from '../../interfaces/LeaderboardTypes'
import { _isEmpty } from '../../utils/helpers/zupeeLodash'
import userIcon from "../../assets/user-icon.svg"
import ImageComponent from '../../components/ImageComponent'
import { useTranslation } from 'react-i18next'
export interface TopWinnersProps {
  data: LeaderboardData;
}
const TopWinners: React.FC<TopWinnersProps> = ({ data }) => {
  const { t } = useTranslation();
  const { topWinners } = data || {};
  const listdata = [
    ...(topWinners || [])
  ];
  return (
    <div className={styles.TopWinnersCard}>
      <div className={styles.WinnersContainer}>
        <ImageComponent
          className={styles.backgroundImage}
          src={winnersbackground}
          alt=''
        />
        <ImageComponent
          className={styles.backgroundImagelines}
          src={backgroundlines}
          alt=''
        />
        <div className={styles.winnersitems}>
          <p className={clsx(styles.WinnersHeading, "fontWeightRegular fontSizeMd")}>
            {t('topWinners')}
          </p>
          <div className={styles.TopWinners}>
            {listdata.map((entry, index) => (
              <div className={styles.playerContainer} key={index}>
                <ImageComponent
                  src={!_isEmpty(entry?.userProfilePic) ? entry?.userProfilePic : userIcon}
                  alt='icon'
                  className={!_isEmpty(entry?.userProfilePic) ? "" : styles.defaultAvatar}
                />
                <p className={clsx("fontWeightMedium fontSizeSm12")}>{entry?.userFullName}</p>
                <p className={clsx("fontWeightMedium fontSizeSm12")}>{entry?.reward}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TopWinners